module.exports = __webpack_public_path__ + "img/quan-ydj.743d5c38.svg";